import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const content = objectWithClassName({
  className: "umd-skip-content",
  backgroundColor: `#fff`,
  color: `#e21833`,
  display: `block`,
  height: `0`,
  width: "0",
  opacity: `0`,
  padding: `8px`,
  position: `absolute`,
  textDecoration: `underline`,
  transition: `none`,
  overflow: "hidden",
  whiteSpace: "nowrap",
  "&:focus": {
    display: "block",
    height: "inherit",
    width: "auto",
    zIndex: "9999",
    opacity: "1",
    transition: "opacity 0.5s"
  }
});
export {
  content
};
//# sourceMappingURL=skip.js.map
